module.exports = __webpack_public_path__ + "img/infrastructure-1.f97cc6cc.png";